import { IconProps } from './IconProps';

export const LightingLowIcon = ({ className, width = 31, height = 32 }: IconProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 31 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#2396FD" fillRule="nonzero">
      <path d="M14.151.5h2.461v6.153h-2.461zM14.151 25.111h2.461v6.152h-2.461zM0 14.652h6.152v2.462H0zM24.611 14.652h6.152v2.462h-6.152zM6.571 8.81l1.74-1.739 1.415 1.414-1.74 1.74zM24.226 8.81l-1.74-1.739-1.414 1.414 1.74 1.74zM6.571 22.985l1.74 1.74 1.415-1.414-1.74-1.74zM24.226 22.985l-1.74 1.74-1.414-1.414 1.74-1.74z" />
    </g>
  </svg>
);
